import React from 'react';
import { Link } from 'react-router-dom';
import AdminJobsView from '../../components/AdminJobsView';
import { SystemStatus } from '../../components/SystemStatus';
import DebugAdminStatus from '../../components/DebugAdminStatus';

const AdminDashboardPage = () => {
  return (
    <div className="space-y-8">
      <div className="card">
        <div className="card-header">
          <h1 className="text-2xl font-bold text-foreground">Admin Dashboard</h1>
          <p className="text-sm text-muted-foreground mt-1">System management and monitoring</p>
        </div>
        
        <div className="card-body">
          {/* Quick Actions */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
            <Link 
              to="/admin/jobs"
              className="p-6 bg-accent rounded-lg hover:bg-blue-100 transition-colors border border-blue-200"
            >
              <div className="text-blue-600 text-2xl mb-3">⚙️</div>
              <h3 className="font-semibold text-foreground mb-1">Job Management</h3>
              <p className="text-sm text-muted-foreground">Monitor and manage background jobs</p>
            </Link>

            <Link 
              to="/admin/system"
              className="p-6 bg-green-50 rounded-lg hover:bg-green-100 transition-colors border border-green-200"
            >
              <div className="text-green-600 text-2xl mb-3">📊</div>
              <h3 className="font-semibold text-foreground mb-1">System Status</h3>
              <p className="text-sm text-muted-foreground">View system health and metrics</p>
            </Link>

            <Link 
              to="/admin/email-sequences"
              className="p-6 bg-purple-50 rounded-lg hover:bg-purple-100 transition-colors border border-purple-200"
            >
              <div className="text-purple-600 text-2xl mb-3">📧</div>
              <h3 className="font-semibold text-foreground mb-1">Email Sequences</h3>
              <p className="text-sm text-muted-foreground">Manage automated email campaigns</p>
            </Link>

            <Link 
              to="/admin/users"
              className="p-6 bg-indigo-50 rounded-lg hover:bg-indigo-100 transition-colors border border-indigo-200"
            >
              <div className="text-indigo-600 text-2xl mb-3">👥</div>
              <h3 className="font-semibold text-foreground mb-1">Users</h3>
              <p className="text-sm text-muted-foreground">View user progress and analytics</p>
            </Link>

            <Link 
              to="/admin/prompts"
              className="p-6 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors border border-orange-200"
            >
              <div className="text-orange-600 text-2xl mb-3">💬</div>
              <h3 className="font-semibold text-foreground mb-1">Prompts</h3>
              <p className="text-sm text-muted-foreground">Configure AI prompts and templates</p>
            </Link>
          </div>

          {/* Recent Jobs Overview */}
          <div className="border-t pt-8">
            <h2 className="text-lg font-semibold text-foreground mb-4">Recent Jobs</h2>
            <AdminJobsView limit={10} />
          </div>
        </div>
      </div>
      
      <DebugAdminStatus />
    </div>
  );
};

export default AdminDashboardPage;